const getCookieConsent = () => {
  const value = localStorage.getItem("cookie-consent");
  return value === "true";
};

export const cookieConsent = getCookieConsent();
// export const cookieConsent = false;
